module.exports = __webpack_public_path__ + "img/flowscore-white.a4b677a7.png";